import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Settings as SettingsIcon,
  Zap,
  Radio,
} from "lucide-react";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/leads", label: "Leads", icon: Users },
  { to: "/setup", label: "Product Setup", icon: SettingsIcon },
];

export default function Sidebar() {
  const loc = useLocation();
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex md:flex-col md:w-64 border-r border-slate-200 bg-white"
    >
      <div className="flex items-center gap-3 px-6 py-5 border-b border-slate-200">
        <div
          className="h-9 w-9 rounded-md bg-[#002FA7] flex items-center justify-center text-white"
          data-testid="brand-logo"
        >
          <Zap className="h-5 w-5" strokeWidth={2} />
        </div>
        <div>
          <div className="font-display text-[17px] font-extrabold tracking-tight leading-none">
            Profit10x
          </div>
          <div className="label-caps mt-1">AI Revenue Engine · Your Sales OS</div>
        </div>
      </div>

      <nav className="flex-1 p-3 space-y-1">
        {nav.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-[13.5px] font-medium transition-colors ${
                  isActive
                    ? "bg-[#002FA7] text-white"
                    : "text-slate-700 hover:bg-slate-50"
                }`
              }
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
              {n.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-200">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
          <div className="flex items-center gap-2 label-caps text-[#002FA7]">
            <Radio className="h-3 w-3" />
            Engine Live
          </div>
          <p className="mt-2 text-xs text-slate-600 leading-relaxed">
            Claude Sonnet 4.5 · tuned for top 1% SDR playbooks.
          </p>
        </div>
      </div>
    </aside>
  );
}
